// extracted by mini-css-extract-plugin
export default {"root":"form-control_root__Aiaz9","size-xs":"form-control_size-xs__FIq1K"};